module.exports = __webpack_public_path__ + "static/media/reverse.51dc57b7.svg";